<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span
          ><em name="Exhibition"></em><span>/</span
          ><a href="javascript:history.back()">Press Release</a
          ><span>/</span>Publish Press Release
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <div class="container">
            <h1>Publish Press Release</h1>

            <p class="my-3">&nbsp;</p>
            <p class="alert">
              Do not upload content that is irrelevant to this exhibition. The
              organizer reserves the right to delete inappropriate content.
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddEnNews">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">Display <span class="red">*</span></p>
              <label
                ><input
                  type="radio"
                  name="Archived"
                  v-model="NewsArchive"
                  value="0"
                  class="largeItem"
                  checked
                />
                Show</label
              >
              <label
                ><input
                  type="radio"
                  name="Archived"
                  v-model="NewsArchive"
                  value="1"
                  class="largeItem ml-2"
                />
                Hide</label
              >
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Topic <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="100"
                  v-model="eNewsTopic"
                  placeholder="Max of 100 characters allowed."
                />
                <span>EN</span>
              </div>
              <div id="error2"></div>
              <p class="divider"></p>
              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="50"
                    v-model="NewsTopic"
                    placeholder="Max of 100 characters allowed."
                  />
                  <span>中 </span>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Link</p>

              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="200"
                  v-model="eNewsLink"
                />
                <span>EN</span>
              </div>

              <p class="divider"></p>
              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="200"
                    v-model="NewsLink"
                  />
                  <span>中 </span>
                </div>
              </div>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">
                Press Release Content (English) <span class="red">*</span>
              </p>
              <ckeditor
                v-model="eNewsContent"
                :config="editorConfig"
              ></ckeditor>

              <div id="error"></div>
              <p class="my-3">&nbsp;</p>
              <div v-if="LocalExh">
                <p class="formTitle">Press Release Content (Chinese)</p>
                <ckeditor
                  v-model="NewsContent"
                  :config="editorConfig"
                ></ckeditor>

                <p class="my-3">&nbsp;</p>
              </div>
              <div class="d-flex justify-content-center">
                <input type="submit" value="Confirm" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backNewsPage">
                  Back
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: `Press Release - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      LocalExh: true,

      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      // date: '',
      //form資訊
      NewsArchive: "0",
      NewsTopic: "",
      eNewsTopic: "",
      NewsLink: "",
      eNewsLink: "",
      NewsContent: "",
      eNewsContent: "",
      NewsAmount: "",
      lang: "en",
    };
  },

  methods: {
    AddNews() {
      const vm = this;

      if (!vm.NewsTopic || !vm.NewsContent) {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        alert("輸入欄位不完整，請重新檢查！");

        if (!vm.NewsTopic) {
          $("#error2").html("<span class='errorTextArea'>請填寫此欄位</span>");
          $("#error").html("<p class='errorTextArea'></p>");

          if (!vm.NewsContent) {
            $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
          }
        } else {
          $("#error2").html("<span class='errorTextArea'></span>");
          $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
        }
      } else {
        if (!vm.NewsContent) {
          alert("輸入欄位不完整，請重新檢查！");
          $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
        } else {
          // vm.NewsContent = CKEDITOR.instances['NewsContent'].getData()
          // vm.eNewsContent = CKEDITOR.instances['eNewsContent'].getData()

          const url = "/apiExhibitors/ExhibitorNews/";

          const info = {
            RegNo: vm.RegNo,
            NewsTopic: vm.NewsTopic,
            eNewsTopic: vm.eNewsTopic,
            NewsUrl: vm.NewsLink,
            eNewsUrl: vm.eNewsLink,
            NewsContent: vm.NewsContent,
            eNewsContent: vm.eNewsContent,
            Archived: vm.NewsArchive,
            CSRF: vm.CSRF_Token,
          };

          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("您已成功新增新聞稿！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            }
          });
        }
      }
    },

    AddEnNews() {
      const vm = this;

      if (!vm.eNewsTopic || !vm.eNewsContent) {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        alert("There are incomplete fields, please check again.");

        if (!vm.eNewsTopic) {
          $("#error2").html(
            "<span class='errorTextArea'>This field is required.</span>"
          );
          $("#error").html("<p class='errorTextArea'></p>");

          if (!vm.eNewsContent) {
            $("#error").html(
              "<p class='errorTextArea'>This field is required.</p>"
            );
          }
        } else {
          $("#error2").html("<span class='errorTextArea'></span>");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        }
      } else {
        if (!vm.eNewsContent) {
          alert("There are incomplete fields, please check again.");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        } else {
          const url = "/apiExhibitors/ExhibitorNews/";

          const info = {
            RegNo: vm.RegNo,
            NewsTopic: vm.NewsTopic,
            eNewsTopic: vm.eNewsTopic,
            NewsUrl: vm.NewsLink,
            eNewsUrl: vm.eNewsLink,
            NewsContent: vm.NewsContent,
            eNewsContent: vm.eNewsContent,
            Archived: vm.NewsArchive,
            CSRF: vm.CSRF_Token,
          };

          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("Successfully published news!");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            }
          });
        }
      }
    },

    backNewsPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //語系會自動抓html lang tag

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        }
      });
  },
};
</script>

<style lang="scss"></style>
